import HeadersNonAuth from '../../components/base/HeadersNonAuth';
import RightLoginForm from './components/RightLoginForm';

export default function LoginPage() {
  return (
    <div>
      <HeadersNonAuth />
      <br />
      <br />
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <RightLoginForm />
    </div>
    </div>

  );
}
